export enum Constants {
    ADD_LEARNING_JOURNAL = 'ADD_LEARNING_JOURNAL',
    UPDATE_LEARNING_JOURNAL = 'UPDATE_LEARNING_JOURNAL',
    DELETE_LEARNING_JOURNAL = 'DELETE_LEARNING_JOURNAL',

}
